import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { AuthenticationService } from '../../services/authentication.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { User } from 'src/app/classes/user';


@Component({
	selector: 'app-change-password',
	templateUrl: './change-pwd.component.html',
	styleUrls: ['./change-pwd.component.css']
})
export class ChangePasswordComponent {


	form: UntypedFormGroup = new UntypedFormGroup({
		// currentPassword: new FormControl('', Validators.required),
		newPassword: new UntypedFormControl('', Validators.required),
		newPasswordConfirm: new UntypedFormControl('', Validators.required),
	});
	// hideCurrentPassword = true;
	hideNewPassword = true;
	currentPassword = '';
	disableSubmit = false;

	@Input() user = new User();
	@Output() done = new EventEmitter<boolean>();

	errorMsg = "";


	constructor(
		private authService: AuthenticationService,
		private matSnackBar: MatSnackBar
	) {}


	changePassword() {

		this.errorMsg = '';
		const newPassword = this.form.get('newPassword')?.value;
		const newPasswordConfirm = this.form.get('newPasswordConfirm')?.value;

		// if (this.currentPassword === this.newPassword) {
		// 	this.matSnackBar.open( 'Das neue Passwort muss sich vom vorherigen unterscheiden', '', { duration: 5000 } );
		// 	return;
		// }
		if (newPassword !== newPasswordConfirm) {
			this.errorMsg = "Neue Passwörter stimmen nicht überein";
			this.matSnackBar.open( 'Neue Passwörter stimmen nicht überein', '', { duration: 5000 } );
			return;
		}

		this.disableSubmit = true;

		if( this.user.ebeId ) {

			this.authService.changePassword( newPassword, this.user.ebeId ).subscribe( b => {
				this.disableSubmit = false;
				if( b ) this.done.emit(true);
				else {
					this.errorMsg = "Das neue Passwort wurde abgelehnt. Bitte überprüfen Sie die Stärke."
				}
			});
			
		}
		else {
			this.authService.changeMyPassword( newPassword ).subscribe( b => {
				this.disableSubmit = false;
				if( b ) {
					this.form.reset();
					Object.keys(this.form.controls).forEach(key => {
						this.form.get(key)?.setErrors(null) ;
					});
					this.matSnackBar.open( 'Ihr Passwort wurde geändert' );
				}
				else {
					this.errorMsg = "Das neue Passwort wurde abgelehnt. Bitte überprüfen Sie die Stärke."
				}
			},
			error => {
				this.disableSubmit = false;
				console.log( 'error', error );
				this.matSnackBar.open( 'Ein Fehler ist aufgetreten' );
			});
		}
	}
}
